import {Component} from "@angular/core";
import {EventBus} from "../event/EventBus";
import {ComponentBase} from "../base/ComponentBase";
import {PleaseWaitEvent, PleaseWaitHiddenEvent, PleaseWaitTarget} from "../event/ContentEvents";
import {RaVersion} from "../services/configuration/ra.version";
import {AudioQueueEvent, InterruptAudio} from "../event/AudioQueueEvent";
import {AudioQueueItem, TranslateAudio} from "../services/audio-playback/audioqueue.item";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";
import {BrowserAgent} from "../services/browser/browser.agent";
import {GESTURE_STATUS, GestureEvent} from "../event/GestureEvent";
import {filter} from "rxjs/operators";

@Component({
    selector: "please-wait",
    templateUrl: "./please.wait.component.html",
    styleUrls: ["./please.wait.component.scss"]
})

export class PleaseWaitComponent extends ComponentBase {

    private eventFinishTriggered: boolean = false;
    public showAnimation: boolean = false;
    private currentAudioPlaying: boolean = false;
    public softAnimation: boolean = false;
    private pleaseWaitHiddenCalled: boolean = false;
    private iosAllowCalled: boolean = false;
    private EVENT_FINISHED_WAIT: number = 100;
    private DELAY_BEFORE_AUDIO_PLAYED: number = 5000;
    private browser: string;
    public showAllowModal: boolean = false;
    private lastTarget: PleaseWaitTarget;
    private initialIOSEvent: PleaseWaitEvent;
    private audioContext;

    constructor(private eventBus: EventBus,
                private audioQueueService: AudioQueueService,
                private browserAgent: BrowserAgent) {
        super("CountdownComponent");
        this.determineBrowser();

        if (this.browser === "Safari") {
            let gestureSubscribe = this.eventBus.pipe(filter(e => e instanceof GestureEvent)).subscribe((e: GestureEvent) => {
                if (e.status === GESTURE_STATUS.end_gesture) {
                    this.eventFinishTriggered = true;
                }
            });
            this.subscriptions.push(gestureSubscribe);
        }

        this.listenForVisibility();

    }

    private determineBrowser(): void {
        this.browser = this.browserAgent.getBrowserName();
    }

    private listenForVisibility(): void {

        let pleaseSub = this.eventBus.pipe(filter(e => e instanceof PleaseWaitEvent)).subscribe((event: PleaseWaitEvent) => {

            if (this.browser === "Safari" && !this.iosAllowCalled) {
                this.showAllowModal = true;
                this.iosAllowCalled = true;
                this.initialIOSEvent = event;

            } else {
                this.pleaseWaitFlow(event);
            }
        });

        this.subscriptions.push(pleaseSub);

    }

    private pleaseWaitFlow(event: PleaseWaitEvent): void {
        if (!this.currentAudioPlaying || !event.playAudio) {
            this.showAnimation = event.visible;
            this.eventFinishTriggered = false;
            this.softAnimation = !!event.softVisibility && event.visible;
            this.lastTarget = event.target;
        }

        if (!event.visible) {
            this.eventFinishTriggered = true;
            this.currentAudioPlaying = false;
            this.pleaseWaitHiddenCalled = false;
        }

        if (!this.currentAudioPlaying && event.playAudio) {
            this.pleaseWaitHiddenCalled = false;
            this.playAudioAsNeeded();
        } else if (!this.pleaseWaitHiddenCalled) {
            this.initiatePleaseWaitHiddenCall();
        }
    }

    private initiatePleaseWaitHiddenCall(): void {
        this.pleaseWaitHiddenCalled = true;
        this.eventBus.next(new PleaseWaitHiddenEvent(this.lastTarget));
    }

    private playAudioAsNeeded(): void {
        this.audioQueueService.reset().subscribe(() => {
            setTimeout(() => {
                if (this.showAnimation) {
                    this.currentAudioPlaying = true;
                    this.eventBus.next(new AudioQueueEvent([new AudioQueueItem("RA_PLEASE_WAIT_01", TranslateAudio.YES, () => {
                        if (this.eventFinishTriggered) {
                            this.showAnimation = false;
                            this.currentAudioPlaying = false;
                            this.eventFinishTriggered = false;
                            this.initiatePleaseWaitHiddenCall();
                        } else {
                            this.currentAudioPlaying = false;
                            let pleaseWaitInterval = setInterval(() => {
                                if (this.eventFinishTriggered) {
                                    this.initiatePleaseWaitHiddenCall();
                                    this.currentAudioPlaying = false;
                                    this.eventFinishTriggered = false;
                                    clearInterval(pleaseWaitInterval);
                                }
                            }, this.EVENT_FINISHED_WAIT);
                        }})], InterruptAudio.NO));
                } else if (!this.pleaseWaitHiddenCalled) {
                    this.initiatePleaseWaitHiddenCall();
                }
            }, this.DELAY_BEFORE_AUDIO_PLAYED);
        });
    }

    public okAudio(allow: boolean): void {
        if (allow) {
            this.showAllowModal = false;
            this.pleaseWaitHiddenCalled = false;
            this.showAnimation = true;
            this.softAnimation = false;
            this.lastTarget = this.initialIOSEvent.target;
            this.eventBus.next(new GestureEvent(GESTURE_STATUS.begin_gesture, ""));
            this.playAudioAsNeeded();
        }
    }
}

